// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"v1-z","dimensionLabel":"w1-z","styleChooserControlWrapper":"x1-z","styleChooserControl":"y1-z","disabled":"z1-z","giftCard":"A1-z","styleChooserText":"B1-z"};